/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
import {ApiV0Fibu} from '../api.v0.fibu';
import {RestApiService} from '../../../rest-api.service';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {Observable} from 'rxjs';
import {FinBankRes} from '../../../../contracts/v0/fibu/finapi/finapi.banks.contract';
import {
    FBankAccountRes,
    FBankConTestReq,
    FinApiConnectionStatusRes
} from '../../../../contracts/v0/fibu/banking.contract';
import {FTransactionJobRes} from '../../../../contracts/v0/fibu/finapi/finapi.transaction.contract';


export class ApiV0FibuBanking {
    segment = '/banking';

    constructor(v0: ApiV0Fibu, private rest: RestApiService) {
        this.segment = v0.segment + this.segment
    }

    searchBank(query: string): Observable<BaseCollectionModel<FinBankRes>> {
        return this.rest.get<BaseCollectionModel<FinBankRes>>(
            `${this.segment}/bank?query=${query}`,
            FinBankRes,
        )
    }


    getAccounts(): Observable<BaseCollectionModel<FBankAccountRes>> {
        return this.rest.get<BaseCollectionModel<FBankAccountRes>>(
            `${this.segment}/accounts`,
            FBankAccountRes,
        )
    }

    addConnection(req: FBankConTestReq) {
        return this.rest.post<FBankConTestReq, FinApiConnectionStatusRes>(
            `${this.segment}/connections`,
            FinApiConnectionStatusRes,
            req,
        )
    }

    removeConnection(id: string) {
        return this.rest.delete(`${this.segment}/connections/${id}`)
    }

    getTransactions(searchModel?: SearchModel) {
        let qp = {
            "bookingYear": this.rest.v0.fibu.bookingYear(),
            "bookingMonth": this.rest.v0.fibu.bookingMonth(),
        }
        return this.rest.post<SearchModel, FTransactionJobRes>(
            `${this.segment}/transactions`,
            FTransactionJobRes,
            searchModel ?? new SearchModel({}),
            qp
        )
    }
    
}
